<template>
<div class="chapter">
<div class="inner_page">
<p class="C1797"><strong><span id="page_9"></span>A<span class="small">CKNOWLEDGEMENTS</span></strong></p>
<p class="C1840"><img alt="" src="html/images/Image_8_0.png"/></p>
<p class="P19"><span class="Smallcaps">My first encounter </span>with Basile’s <em>Lo cunto de li cunti </em>was in a graduate seminar on the topic of fairy tales and Italian literature, held at Yale University many years ago. I thank the instructor of that course, Paolo Valesio, for encouraging me to expand my interest in <em>Lo cunto </em>into a dissertation.</p>
<p class="P20">I am grateful to Dartmouth College for the support I have received for pursuing my research on Basile and fairy tales. In 1995 the Ramon and Marguerite Guthrie Fund of Dartmouth made it possible for me to co-organize a two-day workshop on literary fairy tales in France and Italy, a marvelous opportunity for meeting and sharing ideas with scholars from a number of disciplines that greatly enriched my own work, and resulted in the publication of a volume of essays, <em>Out of the Woods: The Origins of the Literary Fairy Tale in Italy and France. </em>During the time off from teaching allowed by a later sabbatical and Junior Faculty Fellowship, I was able to write the better part of this book.</p>
<p class="P20">I am indebted to Jack Zipes for his generous support of this project since its early days, in the form of willingness to read the chapters in their various phases, invaluable suggestions and comments, mentorly guidance, and just plain encouragement. Thanks also to Paolo Cherchi and Keala Jewell for reading large portions of the manuscript.</p>
<p class="P20">This book would still be an idea without the inestimable contributions of my husband, Carmelo Lettere. His unswerving belief in the need to acquaint the English-speaking scholarly community with <em>Lo cunto; </em>the insights he has brought to our decades-long conversations about Basile, fairy tales, narrative, and other vital matters; his love—these have all made it possible to tell my own “tale of tales.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Acknowle.vue?0d143605